const NoMatchPage = (): JSX.Element => {
  return <></>;
};

export default NoMatchPage;
